import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal } from '../../elements-modal/modal';
import CustomOfferContainer from '../../app-main/containers/CustomOfferContainer';
import { initAuth } from '../../app-main/actions/auth';

class CustomOfferIOSModal extends Component {
  componentDidMount () {
    const {
      accessToken,
      dispatch
    } = this.props;

    dispatch(initAuth(accessToken));
  }

  renderBody () {
    const { accessToken } = this.props;

    if (accessToken) {
      return (
        <CustomOfferContainer
          {...this.props}
        />
      );
    }
  }

  render () {
    return (
      <Modal
        show
        addCloseIcon={false}
        modalID="custom-offer-form-modal"
        modalSize="lg-size"
        modalType="standard"
        body={this.renderBody()}
      />
    );
  }
}

CustomOfferIOSModal.propTypes = {
  accessToken: PropTypes.string,
  dispatch: PropTypes.func
};

function mapStateToProps (state) {
  return {
    ...state
  };
}

export default connect(mapStateToProps)(CustomOfferIOSModal);
